// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___wc1d_","font_button_m":"font_button_m___oRDcX","font_button_s":"font_button_s___NTyiO","uptime":"uptime___arsDX"};